import axios from 'axios';
import config from '../config';

export const initReplay = async ({
  mrDate,
  mrMinTime,
  hrMinTime,
  metRateSensors,
  heartRateSensors,
  jwt,
}) => {
  const { dataUrl, dataApiKey } = config || {};
  return axios({
    method: 'POST',
    url: `${dataUrl}/replay`,
    data: ({
      msCorrection: 0,
      timestamp: `${mrDate}T${mrMinTime || hrMinTime}`,
      metRateSensors,
      heartRateSensors,
      jwt,
    }),
    headers: {
      'X-API-KEY': dataApiKey,
    },
    validateStatus: () => true, // do not throw errors on status >= 400
  });
};

export default { initReplay };
